export default "__VITE_ASSET__0CWCRzCv__"